'use strict';

function thunkMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;

  return function (next) {
    return function (action) {
      return typeof action === 'function' ? action(dispatch, getState) : next(action);
    };
  };
}

module.exports = thunkMiddleware;


//////////////////
// WEBPACK FOOTER
// ../~/redux-thunk/lib/index.js
// module id = 1125
// module chunks = 0